var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"report__display-title"},[_vm._v(_vm._s(String(_vm.text)))])}
var staticRenderFns = []

export { render, staticRenderFns }